import { Flex, Radio, type RadioChangeEvent } from "antd";
import { useIntl } from "react-intl";
import { useAppSettings } from "~context/AppSettingsContext/AppSettingsContext.tsx";
import { TableDensityEnum } from "~enums/tableDensity.ts";

export const TableDensity = () => {
  const { toggleTableDensity, tableDensity } = useAppSettings();
  const onChange = (e: RadioChangeEvent) => {
    toggleTableDensity(e.target.value);
  };

  const { formatMessage } = useIntl();

  return (
    <div>
      <div className="app-settings-content-block-title">{formatMessage({ id: "app.settings.display.density" })}</div>
      <Radio.Group
        onChange={onChange}
        className={"display-width-radio-group"}
        value={tableDensity}
        options={[
          {
            value: TableDensityEnum.DEFAULT,
            label: (
              <Flex gap="small" justify="space-between" align="center" className="display-width-option">
                <div className="display-width-option-title">{formatMessage({ id: "app.settings.display.density.default" })}</div>
                <Flex justify="center" align="center" vertical gap={2} className="display-width-box">
                  <div className="display-table-row-content display-table-row-content-medium"></div>
                  <div className="display-table-row-content display-table-row-content-medium"></div>
                  <div className="display-table-row-content display-table-row-content-medium"></div>
                </Flex>
              </Flex>
            ),
          },
          {
            value: TableDensityEnum.COMPACT,
            label: (
              <Flex gap="small" justify="space-between" align="center" className="display-width-option">
                <div className="display-width-option-title">{formatMessage({ id: "app.settings.display.density.compact" })}</div>
                <Flex justify="center" align="center" vertical gap={2} className="display-width-box">
                  <div className="display-table-row-content display-table-row-content-small"></div>
                  <div className="display-table-row-content display-table-row-content-small"></div>
                  <div className="display-table-row-content display-table-row-content-small"></div>
                  <div className="display-table-row-content display-table-row-content-small"></div>
                </Flex>
              </Flex>
            ),
          },
          {
            value: TableDensityEnum.COMFORTABLE,
            label: (
              <Flex gap="small" justify="space-between" align="center" className="display-width-option">
                <div className="display-width-option-title">{formatMessage({ id: "app.settings.display.density.comfortable" })}</div>
                <Flex justify="center" align="center" vertical gap={2} className="display-width-box">
                  <div className="display-table-row-content display-table-row-content-large"></div>
                  <div className="display-table-row-content display-table-row-content-large"></div>
                </Flex>
              </Flex>
            ),
          },
        ]}
      ></Radio.Group>
    </div>
  );
};
